import { useState, useCallback, useMemo } from 'react';
import { ensureArray } from 'BMapsUtil/js_utils';
import { App } from '../../../BMapsApp';
import useEventBrokerSubscription from './useEventBrokerSubscription';

/**
 * React hook returning the selected atoms from the workspace.
 * This triggers rerenders when the selection changes.
 * @returns {Array<Atom>} the selected atoms
 *
 * Note: additionalEvents is captured only once and will not rerender if changed.
 */
export default function useSelectedAtoms({
    additionalEvents=[],
}={}) {
    const [selectedAtoms, setSelectedAtoms] = useState(getSelectedAtoms());

    // EventBroker events are chosen from places that change the selection or the available atoms.
    const eventList = useMemo(() => {
        const moreEvents = ensureArray(additionalEvents);
        return [
            'selectionDisplay', 'zapAll',
            'proteinsChanged', 'proteinLoaded',
            'compoundDeleted', 'removeAtoms',
            ...moreEvents,
        ];
    }, []);

    const update = useCallback(() => {
        setSelectedAtoms(getSelectedAtoms());
    }, []);

    useEventBrokerSubscription(eventList, update);
    return selectedAtoms;
}

function getSelectedAtoms() {
    return App.Ready ? App.Workspace.getSelectedAtoms() : [];
}
